import { ORDER_STATUS_PHASE } from './constants/orderStatus.constants';
import OrderStatusFailed from './components/OrderStatusFailed';
import OrderStatusPending from './components/OrderStatusPending';
import OrderStatusSuccess from './components/OrderStatusSuccess';
import useOrderStatusPage from './hooks/useOrderStatusPage';
import { PageShell } from './orderStatusPage.styles';

const OrderStatusPage = () => {
	const { phase, params, timeoutTriggered } = useOrderStatusPage();

	return (
		<PageShell>
			{phase === ORDER_STATUS_PHASE.VERIFYING && <OrderStatusPending />}
			{phase === ORDER_STATUS_PHASE.SUCCESS && (
				<OrderStatusSuccess params={params} />
			)}
			{phase === ORDER_STATUS_PHASE.FAILED && (
				<OrderStatusFailed params={params} timeoutTriggered={timeoutTriggered} />
			)}
		</PageShell>
	);
};

export default OrderStatusPage;
